export const SET_VOLUME = 'SET_VOLUME';

export const setVolume = volume => {
  return {
    type: SET_VOLUME,
    volume
  };
};
